export default __webpack_public_path__ + "static/media/donation-desktop.6bae710e.png";